import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
/**
 * Zustand store for managing creator attribution tokens with session storage persistence
 */
export const useCreatorAttributionStore = create()(persist((set, get) => ({
    /** Initial state */
    creatorAttributionToken: '',
    creatorRedirectUrl: '',
    /**
     * Sets the creator attribution token from API response
     * @param token - Raw base64 encoded token string from API
     */
    setCreatorAttributionToken: (token) => {
        set({
            creatorAttributionToken: token,
        });
    },
    /**
     * Retrieves the current token for API calls
     * @returns Current token string
     */
    getCreatorAttributionToken: () => {
        return get().creatorAttributionToken;
    },
    /**
     * Sets the creator redirect URL from DOM data attribute
     * @param url - Creator redirect URL string
     */
    setCreatorRedirectUrl: (url) => {
        set({
            creatorRedirectUrl: url,
        });
    },
    /**
     * Retrieves the creator redirect URL
     * @returns Current redirect URL string
     */
    getCreatorRedirectUrl: () => {
        return get().creatorRedirectUrl;
    },
    /**
     * Clears all token data from the store
     */
    clearToken: () => {
        set({
            creatorAttributionToken: '',
        });
    },
    /**
     * Clears the creator redirect URL from the store
     */
    clearRedirectUrl: () => {
        set({
            creatorRedirectUrl: '',
        });
    },
    /**
     * Clears all data (token and redirect URL) from the store
     */
    clearAll: () => {
        set({
            creatorAttributionToken: '',
            creatorRedirectUrl: '',
        });
    },
}), {
    name: 'creator-attribution-storage',
    storage: createJSONStorage(() => sessionStorage),
}));
